module.exports = __webpack_public_path__ + "static/media/forward-arrow-button.5d1d242e.svg";